// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B3AYc5ylvXxoNwhlpZrR {
  width: 100%;
}

.k338SwXhXtWIUNaBK5uP {
  padding-top: 32px;
}

.BGdmVQYqtuOXw2fOWyGh {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.SzXw2Kcqm5jEGpwNJ4TB {
  display: flex;
  align-items: center;
}

.I3lFk5IZgtyLp1YmPted {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-regular);
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: -0.32px;
  margin-left: 32px;
  margin-right: 16px;
}

.ACI33uqQ2moANNtNd4Vw {
  max-width: 600px;
}

.SB2OpbnVbmt80EXvCrzO {
  display: flex;
  justify-content: center;
  width: 100%;
}

.nMYJpYKD7QRGJsNL8SGq {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}

.m6p_IHOmtqdgU0CQgDGv {
  background: var(--grey-color-10);
  padding: 32px;
}

.RpwESZmJsZXI90S6l0yx {
  padding: 32px;
  background: var(--grey-gradient-start-color-10);
  border-radius: 25px;
  margin-top: 32px;
}

.FpNoZD_YYSAd1Q0uRLLb {
  background: var(--grey-gradient-start-color-10);
  padding: 16px 32px;
  border-radius: 10px;
}

.Ow68ciQSPRiioGqLaG75 {
  color: var(--grey-color-70);
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  font-style: normal;
  font-weight: 350;
  line-height: 24px;
  width: 60%;
  margin: 32px;
}

.i9jx8aSZ90l737s3vo_Q {
  color: var(--grey-color-70);
  font-family: var(--font-stack-full-medium);
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px;
}

.keCSYTud0eqyse2MrOJX {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
}

.y0j5ZJLxMd0hz0d_V4_Y {
  margin: 32px 0;
}

.SK5chMDOH_HJeeDdtbIe {
  display: flex;
  justify-content: space-between;
}

.hDhzEWpFikdxHOHYsr5Q {
  color: var(--grey-color-70);
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px;
}

.i7Q6y95ac6L_9e2Pjny0 {
  width: 50%;
}

.JIcfwUeLYwvmYXL3wL0Z {
  display: flex;
  justify-content: flex-start;
}

._2MZ77ojxYSipsONhUYJ {
  margin-bottom: 25px;
  margin-top: 30px;
}

.L96DmVlLSLieZCaky6Js {
  border-top: 1px solid var(--grey-gradient-end-color-10);
  width: 100%;
  margin-top: 24px;
}

.i2NSSZF1AKRSdhhoSLJq {
  display: flex;
  flex-direction: column;
  margin: 16px 0;
  gap: 24px;
  padding: 0 16px;
}

.secWApiSGKls3RTEcwva {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-medium);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}

.egO8SLMoKn0Pq48kW5Yd {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-medium);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}

.vcOMvN6Vag2OxUPiorz5 {
  display: flex;
  justify-content: center;
  padding-left: 150px;
}

.NJazjdL9RofeN9mnbttT {
  margin-top: 32px;
  display: flex;
  flex-direction: row;
}

._wkEBRjA2tgBa0ICGP4q {
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: flex-end;
  width: 100%;
}

.x4Dr68shu4NM9Q9ndU6Q {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
  bottom: 20px;
}

.kJtSCVq39HByN_GpwFje {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;
}

.x6y_f9l7SIRpW7kDULnW {
  display: flex;
  flex-direction: row;
  gap: 32px;
}

.Nhgh_iT6kcTjirYHueeV {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/components/LeaderInsights/LeaderInsights.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,2BAAA;EACA,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;AAEF;;AACA;EACE,gCAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,+CAAA;EACA,kBAAA;EACA,mBAAA;AAEF;;AACA;EACE,2BAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;AAEF;;AACA;EACE,2BAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;AAEF;;AACA;EACE,2BAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,aAAA;EACA,2BAAA;AAEF;;AACA;EACE,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,uDAAA;EACA,WAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;AAEF;;AACA;EACE,2BAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEF;;AACA;EACE,2BAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,WAAA;AAEF;;AACA;EACE,YAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAEF;;AACA;EACE,YAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;AAEF","sourcesContent":[".factorScoreInnerBox {\n  width: 100%;\n}\n\n.factorScoreBars {\n  padding-top: 32px;\n}\n\n.factorScoreColumnContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.StyledMainContainer {\n  display: flex;\n  align-items: center;\n}\n\n.StyledAllLeaderText {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-regular);\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 40px;\n  letter-spacing: -0.32px;\n  margin-left: 32px;\n  margin-right: 16px;\n}\n\n.textWidthLimiter {\n  max-width: 600px;\n}\n\n.centerHorizontally {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.centerVertically {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  height: 100%;\n}\n\n.StyledMainBg {\n  background: var(--grey-color-10);\n  padding: 32px;\n}\n\n.StyledCard {\n  padding: 32px;\n  background: var(--grey-gradient-start-color-10);\n  border-radius: 25px;\n  margin-top: 32px;\n}\n\n.statusCardContainer {\n  background: var(--grey-gradient-start-color-10);\n  padding: 16px 32px;\n  border-radius: 10px;\n}\n\n.StyledParagraph {\n  color: var(--grey-color-70);\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 350;\n  line-height: 24px;\n  width: 60%;\n  margin: 32px;\n}\n\n.StyledAvgText {\n  color: var(--grey-color-70);\n  font-family: var(--font-stack-full-medium);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.filterDivStyle {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 32px;\n}\n\n.divider {\n  margin: 32px 0;\n}\n\n.ScorechartDiv {\n  display: flex;\n  justify-content: space-between;\n}\n\n.StyletotalLeadersText {\n  color: var(--grey-color-70);\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.halfWidthBox {\n  width: 50%;\n}\n\n.flexStartBox {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.factorScoreBox {\n  margin-bottom: 25px;\n  margin-top: 30px;\n}\n\n.horizontalRule {\n  border-top: 1px solid var(--grey-gradient-end-color-10);\n  width: 100%;\n  margin-top: 24px;\n}\n\n.factorScoreSection {\n  display: flex;\n  flex-direction: column;\n  margin: 16px 0;\n  gap: 24px;\n  padding: 0 16px;\n}\n\n.factorScoreTitle {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-medium);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n}\n\n.factorHeading {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-medium);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n}\n\n.centerHeadingBox {\n  display: flex;\n  justify-content: center;\n  padding-left: 150px;\n}\n\n.factorRowBox {\n  margin-top: 32px;\n  display: flex;\n  flex-direction: row;\n}\n\n.factorScoreRowBox {\n  display: flex;\n  flex-direction: row;\n  gap: 32px;\n  align-items: flex-end;\n  width: 100%;\n}\n\n.factorScoreHalfWidthBoxRight {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  position: relative;\n  bottom: 20px;\n}\n\n.factorScoreHalfWidthBox {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.factorScoreHeaderRow {\n  display: flex;\n  flex-direction: row;\n  gap: 32px;\n}\n\n.factorRowBoxColumn {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"factorScoreInnerBox": `B3AYc5ylvXxoNwhlpZrR`,
	"factorScoreBars": `k338SwXhXtWIUNaBK5uP`,
	"factorScoreColumnContainer": `BGdmVQYqtuOXw2fOWyGh`,
	"StyledMainContainer": `SzXw2Kcqm5jEGpwNJ4TB`,
	"StyledAllLeaderText": `I3lFk5IZgtyLp1YmPted`,
	"textWidthLimiter": `ACI33uqQ2moANNtNd4Vw`,
	"centerHorizontally": `SB2OpbnVbmt80EXvCrzO`,
	"centerVertically": `nMYJpYKD7QRGJsNL8SGq`,
	"StyledMainBg": `m6p_IHOmtqdgU0CQgDGv`,
	"StyledCard": `RpwESZmJsZXI90S6l0yx`,
	"statusCardContainer": `FpNoZD_YYSAd1Q0uRLLb`,
	"StyledParagraph": `Ow68ciQSPRiioGqLaG75`,
	"StyledAvgText": `i9jx8aSZ90l737s3vo_Q`,
	"filterDivStyle": `keCSYTud0eqyse2MrOJX`,
	"divider": `y0j5ZJLxMd0hz0d_V4_Y`,
	"ScorechartDiv": `SK5chMDOH_HJeeDdtbIe`,
	"StyletotalLeadersText": `hDhzEWpFikdxHOHYsr5Q`,
	"halfWidthBox": `i7Q6y95ac6L_9e2Pjny0`,
	"flexStartBox": `JIcfwUeLYwvmYXL3wL0Z`,
	"factorScoreBox": `_2MZ77ojxYSipsONhUYJ`,
	"horizontalRule": `L96DmVlLSLieZCaky6Js`,
	"factorScoreSection": `i2NSSZF1AKRSdhhoSLJq`,
	"factorScoreTitle": `secWApiSGKls3RTEcwva`,
	"factorHeading": `egO8SLMoKn0Pq48kW5Yd`,
	"centerHeadingBox": `vcOMvN6Vag2OxUPiorz5`,
	"factorRowBox": `NJazjdL9RofeN9mnbttT`,
	"factorScoreRowBox": `_wkEBRjA2tgBa0ICGP4q`,
	"factorScoreHalfWidthBoxRight": `x4Dr68shu4NM9Q9ndU6Q`,
	"factorScoreHalfWidthBox": `kJtSCVq39HByN_GpwFje`,
	"factorScoreHeaderRow": `x6y_f9l7SIRpW7kDULnW`,
	"factorRowBoxColumn": `Nhgh_iT6kcTjirYHueeV`
};
export default ___CSS_LOADER_EXPORT___;
